import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  private apiUrl = environment.apiBaseUrl + '/api/';

  constructor(private http: HttpClient) { }

  getAllLocations(langCode: string): Observable<any> {
    if (langCode === '') {
      return this.http.get(`${this.apiUrl}location`);
    }

    return this.http.get(`${this.apiUrl}location?lang=${langCode}`);
  }

  getLocationById(id: number, langCode: string): Observable<any> {
    if (langCode === '') {
      return this.http.get(`${this.apiUrl}location/${id}`);
    }

    return this.http.get(`${this.apiUrl}location/${id}?lang=${langCode}`);
  }

  create(request: any): Observable<any> {
    return this.http.post(`${this.apiUrl}location`, request);
  }

  update(id: number, request: any): Observable<any> {
    return this.http.put(`${this.apiUrl}location/${id}`, request);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}location/${id}`);
  }
}
